<div class="container">
  <h1 class="mb-3">{{'resource-policies.edit.page.heading' | translate}} {{resourcePolicy.id}}</h1>

  <ds-resource-policy-form [resourcePolicy]="resourcePolicy"
                           [isProcessing]="isProcessing()"
                           (reset)="redirectToAuthorizationsPage()"
                           (submit)="updateResourcePolicy($event)"></ds-resource-policy-form>
</div>
